import { axiosClient } from '../utils/axiosClient.js';
import * as Paths from '@/components/common/paths';
import { handleServerError } from '@/components/common/errorUtils';
import i18n from '@/i18n';

// 翻訳キーから値を取得するヘルパー関数
const t = (key) => {
    try {
        return i18n.global.t(key);
    } catch (e) {
        return '';
    }
};

const actions = {
    async update(_, updateData) {
        try {
            const response = await axiosClient.post(`${Paths.REPORT_URL}`, updateData);
            const data = response.data;

            if (data.type === 0) {
                return { success: true };
            } else {
                console.error('Unexpected data type:', data.type);
                return { success: false, error: 'Unexpected data type' };
            }
        } catch (error) {
            console.error(handleServerError(error));
            return { success: false, error: t('errors.data_registration_failed') };
        }
    },

    async uploadS3(_, paramsS3) {
        try {
            const response = await axiosClient.post(`${Paths.UPLOAD_S3_URL}`, paramsS3);
            const data = response.data;

            if (data.type === 0) {
                return { success: true };
            } else {
                console.error('Unexpected data type:', data.type);
                return { success: false, error: 'Unexpected data type' };
            }
        } catch (error) {
            console.error(handleServerError(error));
            return { success: false, error: t('errors.s3_upload_failed_connection') };
        }
    },
}

export default {
    namespaced: true,
    actions,
};